import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import { useRosterContext } from "../contexts/Roster";
import useRosterHandlers from "../hooks/useRosterHandlers";

import Loading from "../../../../../components/Loading";

const CoachButtons = (): React.JSX.Element => {
    const { handleWaiverClick } = useRosterHandlers();
    const { sending } = useRosterContext();

    return (
        <div data-testid="coachButtons">
            <Link
                to={`add`}
                className={`btn btn-primary${sending ? " disabled" : ""}`}
                aria-disabled={sending}
            >
                Add Player
            </Link>
            <Button
                variant="primary"
                onClick={handleWaiverClick}
                disabled={sending}
            >
                {sending ? "Sending waivers...." : "Send Waiver Request"}
            </Button>
            {sending && <Loading className="mx-3 w-auto" />}
        </div>
    );
};

export default CoachButtons;
